module.exports = __webpack_public_path__ + "components/flag/static/square/gb-sct-f12ee0b042060493b4e21b6f8a9a17a7.svg";